/**
 * Corriger le prénom, le nom et l'intitulé de poste d'un membre (2026-10-25) : ce qui se décide sans écran.
 *
 * Seuls les champs qui CHANGENT partent au serveur : un nom inchangé n'est pas envoyé, donc un membre d'un autre
 * espace (dont le nom ne se change pas d'ici) peut encore voir son intitulé de poste corrigé.
 */
export interface SaisieMembre {
  readonly firstName: string;
  readonly lastName: string;
  readonly jobTitle: string;
}

export interface MembreModifiable {
  readonly firstName: string | null;
  readonly lastName: string | null;
  readonly jobTitle: string | null;
}

/** Espaces rognés et compressés ; vide = absent (`null`). Même règle que le serveur. */
export function texteNettoye(valeur: string): string | null {
  const propre = valeur.replace(/\s+/g, ' ').trim();
  return propre === '' ? null : propre;
}

export function saisieDepuis(m: MembreModifiable): SaisieMembre {
  return { firstName: m.firstName ?? '', lastName: m.lastName ?? '', jobTitle: m.jobTitle ?? '' };
}

/** Le corps du `PATCH` : seulement les champs changés ; `null` quand rien ne change. */
export function changementsMembre(
  m: MembreModifiable,
  s: SaisieMembre,
): { firstName?: string | null; lastName?: string | null; jobTitle?: string | null } | null {
  const corps: { firstName?: string | null; lastName?: string | null; jobTitle?: string | null } = {};
  const prenom = texteNettoye(s.firstName);
  const nom = texteNettoye(s.lastName);
  const poste = texteNettoye(s.jobTitle);
  if (prenom !== (m.firstName ?? null)) corps.firstName = prenom;
  if (nom !== (m.lastName ?? null)) corps.lastName = nom;
  if (poste !== (m.jobTitle ?? null)) corps.jobTitle = poste;
  return Object.keys(corps).length === 0 ? null : corps;
}

/** Un compte sans prénom ni nom n'apparaît pas dans « Accès au téléphone » : à dire au moment de l'effacer. */
export function avertissementSansNom(s: SaisieMembre): string | null {
  return texteNettoye(s.firstName) === null && texteNettoye(s.lastName) === null
    ? 'Sans prénom ni nom, ce compte n’apparaîtra pas dans la liste « Accès au téléphone » des techniciens.'
    : null;
}
